<script>
import CompareHeader from '../components/product/compare/CompareHeader.vue';
import CompareList from '../components/product/compare/CompareList.vue';

export default {
  name: 'CompareView',
  components: { CompareHeader, CompareList },
};
</script>

<template>
  <div class="flex flex-col">
    <CompareHeader />

    <CompareList class="mt-10" />
  </div>
</template>
